var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackAddButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 92,
    viewBox: "0 0 152 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.354,
    height: 25.38,
    transform: "translate(0.454 -0.222)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14545 6207)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 152,
    height: 92,
    transform: "translate(-14545 -6207)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14471.176 -6183.309) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2.828 1.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.348,24.06a2.715,2.715,0,0,1-1.919-.793l-7.4-7.4-7.4,7.4A2.714,2.714,0,1,1,.793,19.428l7.4-7.4-7.4-7.4A2.714,2.714,0,0,1,4.632.793l7.4,7.4,7.4-7.4a2.712,2.712,0,0,1,3.838,3.831l-7.4,7.4,7.4,7.4a2.713,2.713,0,0,1-1.919,4.632",
    transform: "translate(2.362 0.699)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackAddButton);
export default __webpack_public_path__ + "static/media/backAddButton.62e37fb8868157de893db4ca75721c45.svg";
export { ForwardRef as ReactComponent };